import { Injectable, EventEmitter, Injector } from '@angular/core'
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, firstValueFrom, Observable, of, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { AlertController, LoadingController, MenuController, ModalController, ToastController } from '@ionic/angular';
import { IdbService } from './idb.service';
import { formatDate, LocationStrategy, Location } from '@angular/common';
import { GpsService } from './gps.service';
import { AppEnum } from '../appenum';
import { DomSanitizer } from '@angular/platform-browser';
import { ThemingService } from './theming.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from '../app.settings';
import { environment } from 'src/environments/environment';
import { EncryptionService } from './encryption.service';
import * as CryptoJS from 'crypto-js';
import { SelectLanguageComponent } from '../shared/select-language/select-language.component';
import { ModelPopupComponent } from '../shared/model-popup/model-popup.component';
import { Router, NavigationStart } from '@angular/router';
import { wrapAllMethodsWithLogging } from 'src/app/core/decorators/log-all-errors.decorator';
import { LoggingService } from './logging.service';
import { AppNavigation } from './app-navigation';
// import { MediaUploadProgressComponent } from '../shared/media-upload-progress/media-upload-progress.component';
// import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';

declare var google: any;

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private loader: HTMLIonLoadingElement | null = null;
  public appType: any = "self";
  public headersOption = new HttpHeaders();
  public isLoading = false;
  public isBackButtonlicked = new EventEmitter(false);
  public UploadMaxRetryHit = 3;
  online$: Observable<boolean>;
  // isconnected: boolean;
  public static dateFormat = "EEE MMM dd YYYY HH:mm:ss ZZZZ";
  public apiUrl = `${environment.apiUrl}`;
  level = this._appenum.EntityOfLogLevel.All;
  logWithDate: boolean = true;
  public inpOrgID = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId));
  public isDataLoading = new BehaviorSubject(true);
  public isDataUpdated = new BehaviorSubject(false);
  public isMetaDataUpdating = new BehaviorSubject(false);
  public isLangDataLoading = new BehaviorSubject(false);
  public selectedTempFileUrl;
  selectedLanguage: any;
  lang: any;
  errorMessages: any;
  pinRequireText: any;
  pinMinLengthRequireText: any;
  minMaxLengthRequireText: any;
  secretKeyForDataEnc = "xT46emMu7wJpsQGe"  //key used in Python
  secretIVKeyForDataEnc = "U3U9lKwOGNTk0Rz8";
  public isLanguageChanged = new BehaviorSubject(false);
  addresses: any = [];  // Array to store all addresses
  isModalOpen: any = false;
  public isPrechecklistChange = new BehaviorSubject(false);
  public isTerms_condition = new BehaviorSubject(false);
  previousUrl: string | null = null;
  currentUrl: string | null = null;
  public staticLattitude: any = 28.6520; // Default latitude 
  public staticLongitude: any = 77.2315; // Default longitude
  public staticAccuracy: any = 20; // Default accuracy
  selectedImageDetails: any;
  taskId: any;
  componentName: string = 'AppService';
  heartbeatInterval: any = null;
  private loaderWanted = false;
  private loaderSync: Promise<void> = Promise.resolve();
  constructor(public http: HttpClient, public _appenum: AppEnum, public _toastController: ToastController,
    private _menuCtrl: MenuController,
    // public _openNativeSettings: OpenNativeSettings,
    public loadingController: LoadingController,
    public _gpsService: GpsService,
    public idbservice: IdbService,
    public _locationStrategy: LocationStrategy,
    public _alertController: AlertController,
    private _sanitizer: DomSanitizer,
    public _themingService: ThemingService,
    public _translateService: TranslateService,
    public _appSetting: AppSettings,
    public encryptionService: EncryptionService,
    public modalCtrl: ModalController,
    private router: Router,
    private location: Location,
    private injector: Injector,
    public _nav: AppNavigation
  ) {
    wrapAllMethodsWithLogging(this, this.componentName, this.injector, LoggingService);
    this.lang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    this._translateService.use(this.lang);
    this.pinRequireText = this._translateService.instant('error_message.pin_require_text');
    this.pinMinLengthRequireText = this._translateService.instant('error_message.pin_minlength_text')
    this.minMaxLengthRequireText = this._translateService.instant('error_message.pin_maxlength_text');
  }

  bypassSecurityTrustUrl(url) {
    return this._sanitizer.bypassSecurityTrustUrl(url);
  }

  showMenu() {
    this._menuCtrl.enable(true);
  }

  hideMenu() {
    this._menuCtrl.enable(false);
  }

  async presentLoading(msg = null) {
    if (!this.isLoading) {
      this.isLoading = true;
      return await this.loadingController.create({
        message: msg ? msg : 'Please wait...',
      }).then(a => {
        a.present().then(() => {
          if (!this.isLoading) {
            a.dismiss().then(() => null);
          }
        });
      });
    }
  }

  async loaderDismiss() {
    if (this.isLoading) {
      this.isLoading = false;
      return await this.loadingController.dismiss().then(() => null);
    }
  }


  // async showLoader(message: string = ''): Promise<void> {
  //   if (this.isLoading) {
  //     return; // prevent multiple loaders
  //   }

  //   this.loader = await this.loadingController.create({
  //     message,
  //     spinner: 'crescent',
  //     backdropDismiss: false,
  //     cssClass: 'global-loader'
  //   });

  //   await this.loader.present();
  // }

  // async hideLoader(): Promise<void> {
  //   if (this.loader) {
  //     await this.loader.dismiss();
  //     this.loader = null;
  //   }
  // }

  showLoader(message: string = ''): Promise<void> {
    this.loaderWanted = true;
    return this.syncLoader(message);
  }

  hideLoader(): Promise<void> {
    this.loaderWanted = false;
    return this.syncLoader();
  }
  private syncLoader(message: string = ''): Promise<void> {
    this.loaderSync = this.loaderSync.then(async () => {
      try {
        if (this.loaderWanted && !this.loader) {
          const l = await this.loadingController.create({
            message,
            spinner: 'crescent',
            backdropDismiss: false,
            cssClass: 'global-loader'
          });
          this.loader = l;
          await l.present();
        }
        if (!this.loaderWanted && this.loader) {
          const l = this.loader;
          this.loader = null; // clear first so a failed dismiss can't leave a stale reference
          await l.dismiss();
        }
      } catch {
        this.loader = null;
      }
    });
    return this.loaderSync;
  }

  trimPrefixRequiredItem(desc) {
    return desc.split('] ').length > 1 ? desc.split('] ')[1] : desc.split('*] ')[0];
  }

  async presentToast(msg, className = null) {
    const toast = await this._toastController.create({
      message: msg,
      duration: 2000,
      cssClass: className == null ? 'custom-toast' : 'custom-toast-error',
      position: 'top',
      buttons: [
        {
          icon: 'close',   // 👈 Ionic close icon
          role: 'cancel',   // closes the toast
          handler: () => {
            console.log('Toast Cancelled');
          }
        }
      ]
    });
    toast.present();
  }

  async ionicCustomAlert(title, Subtitle, msg) {
    const alert = await this._alertController.create({
      cssClass: 'ionic-Custom-alertBox',
      header: title,
      subHeader: Subtitle,
      message: msg,
      buttons: ['Ok']
    });
    await alert.present();
  }

  async ionicCustomAlertwithgif(title, Subtitle, msg) {
    // let gifPath = '../../assets/images/checkbox.gif'
    const alert = await this._alertController.create({
      cssClass: 'ionic-Custom-alertBox',
      header: '',
      message: msg,
      buttons: ['Ok']
    });

    await alert.present();
  }

  changeUrlwithDateTimeStamp(url) {
    if (url.indexOf("?") > -1) {
      url = url + '&date=' + new Date().toISOString();
    } else {
      url = url + '?date=' + new Date().toISOString();
    }
    return url;
  }

  async postData(url, data): Promise<Observable<any>> {
    const fullUrl = this.changeUrlwithDateTimeStamp(this.apiUrl + url);
    const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
    const isValidToken = await this.checkTokenExpired();
    if (isValidToken) {
      try {
        const results: any = await firstValueFrom(
          this.http.post(fullUrl, encryptedPayload, { headers: this.headersOption })
        );
        const decrypted = this.decryptDataValues(results?.data);
        return of(decrypted);
      } catch (error) {
        console.error('API Error in postData:', error);
        return throwError(() => error);
      }
    }
  }


  // startHeartbeat() {
  //   this.stopHeartbeat(); // avoid duplicates
  //   this.heartbeatInterval = setInterval(() => {
  //     this.checkTokenExpired();
  //   }, 30000); // check every 30s, independent of any page
  // }

  // stopHeartbeat() {
  //   if (this.heartbeatInterval) {
  //     clearInterval(this.heartbeatInterval);
  //     this.heartbeatInterval = null;
  //   }
  // }
  // async checkTokenExpired() {
  //   const authToken = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken));
  //   const newToken = JSON.parse(atob(authToken.split('.')[1]))
  //   const unixTimestamp = newToken.exp;
  //   const curUnixTimestamp = Math.floor(Date.now() / 1000);
  //   var remainingTime = unixTimestamp - curUnixTimestamp

  //   const BUFFER_SECONDS = 90;
  //   if (remainingTime > BUFFER_SECONDS) {
  //     return true;
  //   } else {
  //     return this.refreshToken().then(res => {
  //       return res;
  //     })
  //   }
  // }

  async checkTokenExpired(): Promise<boolean> {
    try {
      const authToken = this.encryptionService.decrypt(
        this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken)
      );

      if (!authToken) {
        console.warn('checkTokenExpired: no auth token found, treating as expired');
        return await this.refreshToken();
      }

      const payload = authToken.split('.')[1];
      const newToken = JSON.parse(atob(payload));
      const unixTimestamp = newToken.exp;

      if (!unixTimestamp) {
        console.warn('checkTokenExpired: token has no exp claim, treating as expired');
        return await this.refreshToken();
      }

      const curUnixTimestamp = Math.floor(Date.now() / 1000);
      const remainingTime = unixTimestamp - curUnixTimestamp;
      const BUFFER_SECONDS = 90;
      console.log("remainingTime", remainingTime, BUFFER_SECONDS)
      if (remainingTime > BUFFER_SECONDS) {
        return true;
      }
      return await this.refreshToken();

    } catch (error) {
      console.error('checkTokenExpired: failed to parse token, treating as expired', error);
      return await this.refreshToken();
    }
  }

  // async refreshToken(val = null): Promise<any> {
  //   var postJson = {
  //     "orgId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId)),
  //     "userId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.userid)),
  //     "accessToken": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken)),
  //     "refreshToken": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken)),
  //     "sessionId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)),
  //     "deviceId": this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)),
  //   };
  //   return this.postDataWithPromiseWithoutAuth(environment.endpoint.getRefreshToken, postJson).then(async (res) => {
  //     var paramRequest = {
  //       httpRequest: {
  //         method: 'post',
  //         url: environment.endpoint.getRefreshToken,
  //         payLoad: postJson,
  //         response: {
  //           responseCode: res.StatusCode,
  //           responseMsg: res.Message,
  //           result: res
  //         },
  //         // executionTime: ""
  //       },
  //       taskDetails: null
  //     }
  //     this.logsActivity(
  //       res.StatusCode != 200
  //         ? this._appenum.EntityOfLogLevel.Error
  //         : this._appenum.EntityOfLogLevel.Info,
  //       `getRefreshToken Api Call to Refresh token`,
  //       this.componentName,
  //       paramRequest.httpRequest,
  //       paramRequest.taskDetails,
  //       environment.endpoint.getRefreshToken   // apiName — one of your 5 Critical APIs
  //     );
  //     if (res.StatusCode == 200) {
  //       this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.authtoken, res.Data[0].accessToken)
  //       this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken, res.Data[0].refreshToken)
  //       return true;
  //     } else {
  //       this.presentToast('Your session token has expired. Please log in again.')
  //       this.deleteCookie('authToken');
  //       window.location.reload();
  //       return false;
  //     }
  //   });
  // }

  async refreshToken(): Promise<boolean> {
    const postJson = {
      orgId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId)),
      userId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.userid)),
      accessToken: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.authtoken)),
      refreshToken: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken)),
      sessionId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)),
      deviceId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)),
    };

    try {
      const res = await this.postDataWithPromiseWithoutAuth(environment.endpoint.getRefreshToken, postJson);

      const paramRequest = {
        httpRequest: {
          method: 'post',
          url: environment.endpoint.getRefreshToken,
          payLoad: postJson,
          response: {
            responseCode: res?.StatusCode,
            responseMsg: res?.Message,
            result: res
          },
        },
        taskDetails: null
      };

      this.logsActivity(
        res?.StatusCode != 200 ? this._appenum.EntityOfLogLevel.Error : this._appenum.EntityOfLogLevel.Info,
        `getRefreshToken Api Call to Refresh token`,
        this.componentName,
        paramRequest.httpRequest,
        paramRequest.taskDetails,
        environment.endpoint.getRefreshToken
      );

      if (res?.StatusCode == 200) {
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.authtoken, res.Data[0].accessToken);
        this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.refreshToken, res.Data[0].refreshToken);
        return true;
      } else {
        this.presentToast('Your session token has expired. Please log in again.');
        this.deleteCookie('authToken');
        window.location.reload();
        return false;
      }

    } catch (error: any) {
      console.error('refreshToken: API call failed', error);
      this.logsActivity(
        this._appenum.EntityOfLogLevel.Error,
        `getRefreshToken Api Call failed: ${error?.message || error}`,
        this.componentName,
        null,
        null,
        environment.endpoint.getRefreshToken
      );
      this.presentToast('Your session token has expired. Please log in again.');
      this.deleteCookie('authToken');
      window.location.reload();
      return false;
    }
  }

  async prepareFileData(imageFileDetail: any[]): Promise<Map<string, ArrayBuffer>> {
    const bufferMap = new Map<string, ArrayBuffer>();

    const preparedData = [];

    for (const img of imageFileDetail) {
      try {
        let buffer: ArrayBuffer | null = null;
        let mimeType = 'image/jpeg';

        if (img.filePath) {
          const response = await fetch(img.filePath);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          buffer = await response.arrayBuffer();
          mimeType = response.headers.get('content-type') || 'image/jpeg';

          bufferMap.set(img.fileName, buffer);
        }

        preparedData.push({
          cameraorientation: img.cameraorientation,
          createdAt: img.createdAt,
          fileCustomName: this.encryptionService.encrypt(img.serverFileName),
          fileName: img.fileName,
          filePath: img.filePath,
          fileType: img.fileType,
          fileid: img.fileid,
          filelat: img.filelat,
          filelng: img.filelng,
          id: img.id,
          inspectionid: img.inspectionid,
          metadata: img.metadata,
          note: this.encryptionService.encrypt(img.note),
          status: img.status,
          taskId: img.taskId,
          updatedAt: img.updatedAt,
          uploadedBy: img.uploadedBy,
          userType: img.userType,
          LocalFileBuffer: buffer,
          LocalFileMime: mimeType,
          LocalFileUrl: '',
          isDowloadedImage: 'true',
          orgid: this.encryptionService.decrypt(
            this.encryptionService.localstorageDecrypt(
              this._appenum.EntityOfLocalStorageKeys.orgId
            )
          ),
        });

        // Null after push — preparedData holds the reference now
        buffer = null;

      } catch (err: any) {
        // still push without buffer so record is not lost
        preparedData.push({
          ...img,
          LocalFileBuffer: null,
          LocalFileMime: 'image/jpeg',
          LocalFileUrl: '',
          isDowloadedImage: 'true',
        });
      }
    }

    await this.idbservice.addInspectionFilesDetailsBulk(preparedData);

    //Free preparedData buffers after bulk insert
    preparedData.forEach(item => { item.LocalFileBuffer = null; });
    preparedData.length = 0;

    return bufferMap; // return for meta reuse — caller clears it
  }

  async storefilesData(buffer: ArrayBuffer, mimeType: string, originalFileName, zone, photoCategory, controlName, fileName, fileType, taskId, zoneDetails, ImgFileIdForAudio = null, MetaData = null, MetaTag = null, observationText = null, orgid, UploadStatus = 'false', ServerFileName = "") {
    // const cleanBlob = new Blob([await fileUrl.arrayBuffer()], { type: fileUrl.type });
    // const base64String = await this.blobToBase64(cleanBlob);
    // const finalBase64 = base64String ?? await this.blobToBase64(fileUrl);
    const today = new Date();
    var fileName = fileName
    var postJson = {
      taskId: taskId,
      zoneDetails: zoneDetails,
      fileType: fileType,
      LocalFileBuffer: buffer,
      LocalFileMime: mimeType,
      FileSize: "", //
      fileName: fileName,
      UploadStatus: UploadStatus,
      RetryHitting: 0,
      MetaData: MetaData,
      ServerFileID: 0,
      ServerFileName: ServerFileName,
      LiveUrl: '',
      controlName: controlName,
      zone: zone,
      photoCategory: photoCategory,
      originalFileName: originalFileName,
      metaTags: MetaTag,
      ObservationText: observationText,
      orgid: orgid
    }
    await this.idbservice.addInspectionFilesDetails(postJson);
    postJson.LocalFileBuffer = null;
    buffer = null;
  }
  async storeMetaDetaOfFile(
    buffer: ArrayBuffer,
    mimeType: string,
    fileUrl: any,
    fileType,
    TaskID,
    UserID,
    controlId,
    MetaData = null,
    ObservationText = null,
    zoneName,
    photoCategory,
    originalFileName,
    fileSize,
    aiTypeId = null,
    orgId,
    ServerFileName = ''
  ) {
    var fileName = fileUrl.name
    console.log("fileUrl", fileUrl)
    var postJson = {
      TaskID: TaskID,
      uploadedby: UserID,
      controlId: controlId,
      fileType: fileType,
      localFileBuffer: buffer,
      localFileMime: mimeType,
      FileName: this.encryptionService.encrypt(fileName),
      metaData: MetaData,
      observationText: this.encryptionService.encrypt(ObservationText),
      serverFileName: this.encryptionService.encrypt(ServerFileName),
      serverFileUrl: '',
      zoneName: zoneName,
      photoCategory: JSON.stringify(photoCategory),
      originalFileName: this.encryptionService.encrypt(originalFileName),
      AICheck: aiTypeId,
      createdAt: new Date().toISOString(),
      uploadStatus: false,
      status: 'Active',
      orgid: orgId
    };
    console.log("postJson", postJson)
    await this.idbservice.addInspectionMetaFilesDetails(
      postJson
    );
    postJson.localFileBuffer = null;
    buffer = null;
  }

  async storefilesDataAddressVerification(
    file: Blob,
    fileType: string,
    taskId: string,
    zoneDetails: any = null,
    ImgFileIdForAudio: number | null = null,
    MetaData: string | null = null,
    fileName: any,
    UploadStatus: string = 'false',
    ServerFileName: string = ''
  ) {
    // Blob/File -> ArrayBuffer
    const buffer = await file.arrayBuffer();

    const postJson = {
      id: `${taskId}_${fileName}`,
      taskId,
      FileName: fileName,
      FileType: fileType,
      FileSize: file.size,
      MimeType: file.type,        // <-- store mime type so we can rebuild Blob correctly later
      UploadStatus,
      RetryHitting: 0,
      MetaData,
      ServerFileID: 0,
      ServerFileName,
      LiveUrl: '',
      zoneDetails,
      buffer                       // <-- ArrayBuffer instead of base64image
    };
    return await this.idbservice.addressVerificationFilesDetails(postJson);
  }

  async deleteFileDataAddressVerification(fileName: any): Promise<void> {
    console.log("fileName", fileName)
    await this.idbservice.deleteAddressVerificationFile(fileName);
  }

  blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();

        reader.onloadend = () => {
          if (typeof reader.result === 'string') {
            resolve(reader.result); // base64 string
          } else {
            const errorMsg = 'Failed to convert blob to base64';
            alert(errorMsg);
            reject(errorMsg);
          }
        };

        reader.onerror = (err) => {
          alert('Error reading blob: ' + err);
          reject(err);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        alert('Unexpected error while converting blob to base64: ' + error);
        reject(error);
      }
    });
  }

  async clearAddressVerificationTable(taskId) {
    await this.idbservice.clearTableAddressVerificationImage(taskId);
  }

  // async postDataWithPromiseWithoutAuth(url, data): Promise<any> {
  //   var withOutAuth = new HttpHeaders();
  //   withOutAuth.append('Content-Type', 'application/json');
  //   withOutAuth.append('Access-Control-Allow-Headers', 'Content-Type');
  //   withOutAuth.append('Access-Control-Allow-Origin', '*');
  //   withOutAuth.append('ReqBodyenc', 'true');
  //   url = this.apiUrl + url;
  //   const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
  //   var result: any = await this.http.post(this.changeUrlwithDateTimeStamp(url), encryptedPayload, { headers: withOutAuth, }).pipe().toPromise();
  //   return this.decryptDataValues(result?.data);
  // }

  async postDataWithPromiseWithoutAuth(url, data): Promise<any> {
    const withOutAuth = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      'Access-Control-Allow-Origin': '*',
      'ReqBodyenc': 'true',
    });

    url = this.apiUrl + url;

    let serializedData: string;
    try {
      serializedData = JSON.stringify(data);
    } catch (error: any) {
      console.log("error", error)
    }

    let encryptedPayload: any;
    encryptedPayload = { data: await this.encryptDataValues(serializedData) };
    try {
      const result: any = await firstValueFrom(
        this.http.post(this.changeUrlwithDateTimeStamp(url), encryptedPayload, { headers: withOutAuth })
      );
      return this.decryptDataValues(result?.data);
    } catch (error) {
      throw error;
    }
  }

  async postDataWithPromise(url, data): Promise<any> {
    url = this.apiUrl + url;
    const encryptedPayload = { data: await this.encryptDataValues(JSON.stringify(data)) };
    const isValidToken = await this.checkTokenExpired();
    if (isValidToken) {
      try {
        const result: any = await this.http.post(this.changeUrlwithDateTimeStamp(url), encryptedPayload).pipe().toPromise();
        return this.decryptDataValues(result?.data);
      } catch (error) {
        console.error('postDataWithPromise error:', error);
        throw error;
      }
      // var result: any = await this.http.post(this.changeUrlwithDateTimeStamp(url), encryptedPayload).pipe().toPromise();
      // return this.decryptDataValues(result?.data);
    }
  }

  async UploadByPromise(url: string, FileData: any): Promise<any> {
    url = this.apiUrl + url;
    return await this.http.post(url, FileData, { reportProgress: true, observe: 'events', }).toPromise()
  }



  removeBackHistory(res: any, action: any) {
    history.pushState(null, null, location.href);
    this._locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href);
      this.isBackButtonlicked.next({ result: res, doaction: action });
      setTimeout(() => {
        this.isBackButtonlicked.next(false);
      }, 200);
    });
  }

  get_filesDetails_audio_List = (itemsList, InspectionFileId = 0, link = 'ImgFileIdForAudio') =>
    itemsList.filter(item => item[link] == InspectionFileId).map(item => (
      { ...item, AudiosList: this.get_filesDetails_audio_List(itemsList, item.InspectionFileId) }
    ));


  //TimeZone Format

  changeDateformat(inputDate) {
    return formatDate(inputDate, AppService.dateFormat, 'en-US', this.getTimeZoneOffset());
  }

  getTimeZoneOffset() {
    return this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.profileZoneOffset));
  }

  getTimeZone() {
    // return 'Asia/Kolkata'
    return this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.profileTimezone));
  }


  private shouldLog(level: any): boolean {
    let ret: boolean = false;
    if ((level >= this.level && level !== this._appenum.EntityOfLogLevel.Off) || this.level === this._appenum.EntityOfLogLevel.All) {
      ret = true;
    }
    return ret;
  }

  async logsActivity(severity, logTextMsg, componentOrPage, httpRequest = null, taskDetails = null, apiName?: any, functionName?: any) {
    if (this.shouldLog(severity)) {
      try {
        var postJson = {
          severity: this._appenum.EntityOfLogLevel[severity], //"info/error/warning",
          logTextMsg: logTextMsg,
          logtime: new Date().toISOString(),
          userId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)) : null,
          sessionId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) : null,
          deviceId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) : null,
          deviceInfo: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) : null,
          componentOrPage: componentOrPage,
          operationMode: 'Self PWA',
          httpRequest: {
            method: httpRequest ? httpRequest.method : null,
            Url: httpRequest ? httpRequest.url : null,
            payLoad: httpRequest ? httpRequest.payLoad : null,
            response: {
              responseCode: httpRequest ? httpRequest.response?.responseCode : null,
              responseMsg: httpRequest ? httpRequest.response?.responseMsg : null,
              result: httpRequest ? httpRequest.response?.result : null,
            },
            // executionTime: ""
          },
          taskId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId)),
          taskStatus: taskDetails ? taskDetails.status : null,
          taskFormControlDetails: taskDetails,
          ...(apiName ? { apiName } : {}),   // NEW - only included when a real value is passed
          ...(functionName ? { functionName } : {}),
        }
        const res = { data: [postJson] }
        console.log("payload of logs App Service", res);
        await this.postDataWithPromiseWithoutAuth(environment.endpoint.directLogging, res);
      } catch (error) {
        console.error('logsActivity failed to send log:', error);
        // intentionally not rethrown — a failed log must never break the caller's flow
      }
    }
  }

  async logsActivityOfRepairJson(severity, logTextMsg, componentOrPage, httpRequest = null, taskDetails = null, functionName?: any) {
    if (this.shouldLog(severity)) {
      var postJson = {
        severity: this._appenum.EntityOfLogLevel.Warning,
        logTextMsg: logTextMsg,
        logtime: new Date().toISOString(),
        userId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.agentId)) : null,
        sessionId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.sessionID)) : null,
        deviceId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.deviceId)) : null,
        deviceInfo: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) ? this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.DeviceInfo)) : null,
        componentOrPage: componentOrPage,
        operationMode: 'Self PWA',
        httpRequest: {
          method: httpRequest ? httpRequest.method : null,
          templateId: httpRequest ? httpRequest.templateId : null,
          zoneIndex: httpRequest ? httpRequest.zoneIndex : null,
          tempTemplateDataCount: httpRequest ? httpRequest.tempTemplateDataCount : null,
          templateJsonCount: httpRequest ? httpRequest.flatCount : null,
          missingControlNames: httpRequest ? httpRequest.missingControlNames : null,
        },
        taskId: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.taskId)),
        taskStatus: taskDetails ? taskDetails.status : null,
        taskFormControlDetails: taskDetails,
        ...(functionName ? { functionName } : {}),
      }
      var postArray = []
      postArray.push(postJson);
      var res = {
        data: postArray
      }
      console.log("payload of logs repair Json", res)
      this.postDataWithPromiseWithoutAuth(environment.endpoint.directLogging, res).then(async (_res) => {
        console.log("Log")
      }, err => {
        console.log("ERR LOG")

      })
    }
  }



  upload(url, fileData) {
    url = this.apiUrl + url;
    return this.http.post<any>(this.changeUrlwithDateTimeStamp(url), fileData, {
      reportProgress: true,
      observe: 'events'
    }).pipe(map((event) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          const progress = Math.round(100 * event.loaded / event.total);
          return { status: 'progress', message: progress };
        case HttpEventType.Response:
          return event.body;
        default:
          return `Unhandled event: ${event.type}`;
      }
    })
    );
  }

  showFileThumbnail(fileName) {
    var fileExtension = fileName.split('.').pop()
    if (fileExtension == 'pdf') {
      return '/assets/images/pdflogo.png';
    } else if (fileExtension == 'txt') {
      return '/assets/images/fileimage.png';
    } else if (fileExtension == 'pptx' || fileExtension == 'ppt') {
      return '/assets/images/pptImage.jpg';
    } else if (fileExtension == 'docx' || fileExtension == 'doc') {
      return '/assets/images/docimage.jpg';
    }
  }

  async ionicCustomPromptForCors(title, msg) {
    const alert = await this._alertController.create({
      cssClass: 'Confirmation_popup regularFonts',
      header: title,
      message: msg,
      buttons: [
        {
          text: 'OK',
          cssClass: ['confirmation_ok_button', 'confirmation_popup_button'],
          handler: async () => {
          }
        }
      ]
    });
    await alert.present();
  }
  async insertdummyblob(fileUrl) {
    const postJson = {
      blobData: fileUrl
    }
    return await this.idbservice.insertdummyblob(postJson)
  }

  FormErrorMessages() {
    return this.errorMessages = {
      otp: [
        { type: 'required', message: this.pinRequireText },
        { type: 'minlength', message: this.pinMinLengthRequireText },
        { type: 'maxlength', message: this.minMaxLengthRequireText }
      ],
    }
  }
  changelanguage(val: any) {
    setTimeout(() => {
      this.isLanguageChanged.next(val);
    }, 100)
  }

  encryptDataValues(data) {
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc)
    var encrypted: any = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });
    encrypted = encrypted.toString();
    return encrypted.toString();
  }

  decryptDataValues(Base64CBC) {
    var iv = CryptoJS.enc.Utf8.parse(this.secretIVKeyForDataEnc);
    var key = CryptoJS.enc.Utf8.parse(this.secretKeyForDataEnc);
    var decrypted: any = CryptoJS.AES.decrypt(Base64CBC, key, { iv: iv, mode: CryptoJS.mode.CBC });
    decrypted = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decrypted);
  }

  async changelanguageData() {
    const languageArr = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.languageData));
    console.log("languageArr", languageArr)
    const selectedLanguageId = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale))
    const obj = {
      component: SelectLanguageComponent,
      cssClass: 'my-custom-class1',
      componentProps: {
        languageArr,
        selectedLanguageId,
      },
    };
    const modal = await this.modalCtrl.create(obj);
    await modal.present();


    const { data: languageSelected } = await modal.onWillDismiss();

    if (languageSelected?.selectedlanguage !== undefined) {
      const selectedLanguage = languageSelected.selectedlanguage;
      this.encryptionService.localstorageEncrypt(this._appenum.EntityOfLocalStorageKeys.siteLocale, selectedLanguage);
      this._appSetting.selectedLanguage = selectedLanguage;
      this._translateService.use(selectedLanguage);
    } else {
      this._translateService.use(selectedLanguageId);
    }
    this.isPrechecklistChange.next(true);
    this.isTerms_condition.next(true);
    this.FormErrorMessages();
    this.changelanguage(true);
  }

  async openModel(key: any, currentAddress = null) {
    if (this.isModalOpen) {
      return; // If modal is already open, do nothing
    }
    console.log(JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.addresshistory))))
    this.isModalOpen = true;
    var cls;
    var modelId = '';
    let addresses: any = [];
    if (key == 1) {
      cls = 'bottom-sheet-modal'
      addresses = JSON.parse(this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.addresshistory)));
      modelId = 'addressModel'
    } else if (key == 2) {
      cls = 'custom-modal'
    } else if (key == 3) {
      cls = 'congratulations-modal',
        modelId = 'timeoutModel'
    } else if (key == 4) {
      cls = 'custom-permission-model',
        modelId = 'permissionModel'
    }
    console.log(addresses)
    const obj = {
      component: ModelPopupComponent,
      id: modelId,
      cssClass: cls,
      componentProps: {
        key,
        addresses,
        currentAddress
      },
    };
    const modal = await this.modalCtrl.create(obj);
    await modal.present();

    const { data: languageSelected } = await modal.onWillDismiss();
    this.isModalOpen = false;
  }

  async getLocation(taskid): Promise<string[]> {
    return new Promise<string[]>(async (resolve, reject) => {
      const taskDetail = {
        taskId: [taskid]
      };
      const postJson = {
        taskId: [taskid]
      };
      (await this.postData(environment.endpoint.getTaskAddress, postJson)).subscribe(
        async (res: any) => {
          const paramRequest = {
            httpRequest: {
              method: 'post',
              url: 'v2/getTaskAddress',
              payLoad: postJson,
              response: {
                responseCode: res.StatusCode,
                responseMsg: res.Message,
                result: res,
              },
            },
            taskDetails: taskDetail,
          };
          this.logsActivity(
            res.StatusCode != 200
              ? this._appenum.EntityOfLogLevel.Error
              : this._appenum.EntityOfLogLevel.Info,
            'getTaskAddress Api Call',
            this.componentName,
            paramRequest.httpRequest,
            paramRequest.taskDetails,
            environment.endpoint.getTaskAddress);
          if (res.StatusCode == '200') {
            const addresses = res.Data
            // const addresses = await this.convertLatLngToAddress(res.Data);  // Await the addresses from convertLatLngToAddress
            resolve(addresses);  // Resolve with addresses once obtained
          } else {
            reject(new Error(res.Message));
          }
        },
        (err) => {
          const paramRequest = {
            httpRequest: {
              method: 'post',
              url: 'v2/getTaskAddress',
              payLoad: postJson,
              response: {
                responseCode: err.status,
                responseMsg: err.message,
                result: err,
              },
            },
            taskDetails: taskDetail,
          };
          this.logsActivity(this._appenum.EntityOfLogLevel.Error, 'getTaskAddress Api Call', this.componentName, paramRequest.httpRequest, paramRequest.taskDetails, environment.endpoint.getTaskAddress);

          reject(err);  // Reject the promise in case of error
        }
      );
    });
  }

  async convertLatLngToAddress(dataList): Promise<string[]> {
    this.addresses = [];  // Clear previous addresses

    const geocodePromises = dataList.map((item) => {
      return new Promise<void>((resolve) => {
        const metadata = item;
        const lat = metadata?.gpsLat;
        const lng = metadata?.gpsLng;
        const captureDate = metadata?.captureDate;

        if (lat && lng) {
          const latLng = new google.maps.LatLng(lat, lng);
          const request = { latLng: latLng };
          const geocoder = new google.maps.Geocoder();

          geocoder.geocode(request, (results, status) => {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                const address = results[0].formatted_address;
                // this.addresses.push(address);  // Add the address to the array
                this.addresses.push({
                  address,
                  filePath: item?.imageURL,  // Add filePath from item
                  fileLat: lat,
                  fileLng: lng,
                  captureDate: captureDate,
                  fileType: 'images',
                  userid: item?.userId,
                  accuracy: item?.accuracy,
                  isskip: item?.isskip
                });
              }
            } else {
              console.error("Geocode failed for the following reason: " + status);
            }
            resolve();  // Resolve the promise for this geocode request
          });
        } else {
          resolve();  // Resolve immediately if lat or lng is missing
        }
      });
    });

    await Promise.all(geocodePromises);  // Wait until all geocoding is complete
    return this.addresses;  // Return the array of addresses
  }

  setCookie(name: string, value: string, minutes: number, queryParam: string) {
    let expires = "";
    if (minutes) {
      const date = new Date();
      date.setTime(date.getTime() + minutes * 60 * 1000); // Expiration time in milliseconds
      expires = "; expires=" + date.toUTCString();
    }
    // Store both token and query parameter as a structured JSON string
    const cookieValue = JSON.stringify({
      value: value,
      query: queryParam,
      taskId: this.getTabId()
    });
    // Set cookie with the structured value
    const cookieName = `${name}_${this.getTabId()}`
    document.cookie = `${cookieName}=${encodeURIComponent(cookieValue)}${expires}; path=/`;
  }

  deleteCookie(name: string) {
    const cookieName = `${name}_${this.getTabId()}`
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }

  getCookie(name: string, queryParam: string) {
    const cookieName = `${name}_${this.getTabId()}`
    const nameEQ = cookieName + "=";
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length); // Clean spaces

      if (c.indexOf(nameEQ) === 0) {
        const cookieValue = c.substring(nameEQ.length, c.length);

        // Decode and parse the cookie value as JSON
        try {
          const parsedValue = JSON.parse(decodeURIComponent(cookieValue));

          // Ensure the query parameter in the cookie matches the current queryParam
          if (parsedValue.query === queryParam && parsedValue.taskId === this.getTabId()) {
            return parsedValue.value; // Return the token value
          } else {
            console.error('Cookie query parameter mismatch');
            return null; // Query parameter mismatch
          }
        } catch (error) {
          console.error('Error parsing cookie:', error);
          return null;
        }
      }
    }

    // No matching cookie found
    return null;
  }

  getTaskIdFromCookieByHashKey(name: string, hashKey: string): string | null {
    const ca = document.cookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();

      // ✅ Check all cookies that start with name (authToken_)
      if (c.startsWith(`${name}_`)) {
        try {
          const raw = c.substring(c.indexOf('=') + 1);
          const parsed = JSON.parse(decodeURIComponent(raw));

          console.log('Cookie found - parsed:', parsed);

          // ✅ Match by hashKey (query)
          if (parsed.query === hashKey) {
            return parsed.taskId || null;
          }

        } catch (e) {
          console.log('Parse error:', e);
          return null;
        }
      }
    }
    return null;
  }

  getTabId(): string | null {
    return new URLSearchParams(window.location.search).get('taskId')
  }




  // async prepareMetaDetailsOfFile(fileDetails, uploadStatus) {
  //   // Refactored bulk prepare + insert
  //   const preparedData = fileDetails.map(item => ({
  //     TaskID: item.TaskId,
  //     uploadedBy: item.uploadedby,
  //     controlId: item.controlId,
  //     fileType: item.FileType,
  //     localFileUrl: item.LocalFileUrl,
  //     // fileName: this.encryptionService.encrypt(item.FileName),
  //     FileName: this.encryptionService.encrypt(item.FileName),
  //     metaData: item.MetaData,
  //     observationText: this.encryptionService.encrypt(item.ObservationText),
  //     serverFileName: this.encryptionService.encrypt(item.serverFileName),
  //     serverFileUrl: item.ServerFileUrl,
  //     zoneName: item.zone,
  //     photoCategory: JSON.stringify(item.PhotoCategory),
  //     originalFileName: this.encryptionService.encrypt(item.originalFileName),
  //     status: 'Active',
  //     AICheck: item.aiTypeId,
  //     AIObservation: item.llmData || null,
  //     createdAt: new Date().toISOString(),
  //     orgid: this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId))
  //   }));
  //   console.log("preparedData on fileDetails", preparedData)
  //   await this.idbservice.addInspectionMetaFilesDetailsBulk(preparedData);
  // }

  async prepareMetaDetailsOfFile(fileDetails: any[], uploadStatus: boolean): Promise<void> {
    try {
      const preparedData = fileDetails.map(item => ({
        TaskID: item.TaskId,
        uploadedBy: item.uploadedby,
        controlId: item.controlId,
        fileType: item.FileType,
        localFileBuffer: item.localFileBuffer ?? null,  // was: localFileUrl: item.LocalFileUrl
        localFileMime: item.localFileMime ?? 'image/jpeg', // new
        FileName: this.encryptionService.encrypt(item.FileName),
        metaData: item.MetaData,
        observationText: this.encryptionService.encrypt(item.ObservationText),
        serverFileName: this.encryptionService.encrypt(item.serverFileName),
        serverFileUrl: item.ServerFileUrl,
        zoneName: item.zone,
        photoCategory: JSON.stringify(item.PhotoCategory),
        originalFileName: this.encryptionService.encrypt(item.originalFileName),
        status: 'Active',
        uploadStatus: uploadStatus,
        AICheck: item.aiTypeId,
        AIObservation: item.llmData || null,
        createdAt: new Date().toISOString(),
        orgid: this.encryptionService.decrypt(
          this.encryptionService.localstorageDecrypt(
            this._appenum.EntityOfLocalStorageKeys.orgId
          )
        )
      }));
      await this.idbservice.addInspectionMetaFilesDetailsBulk(preparedData);

    } catch (err: any) {
      console.log("error after download & save", err)
    }
  }





  async prepareTaskTemplateData(TaskTemplateDetail, AgentId: any) {
    // Refactored bulk prepare + insert
    const preparedData = TaskTemplateDetail.map(item => ({
      createdAt: item.createdAt,
      noCatImageReason: item.noCatImageReason,
      status: item.status,
      taskId: item.taskId,
      templateId: item.templateId,
      templateJson: JSON.stringify(item.templateJson),
      templateJsonValue: JSON.stringify(item.templateJsonValue),
      templateName: this.encryptionService.encrypt(item.templateName),
      templateQues: JSON.stringify(item.templateQues),
      templateQuesValue: JSON.stringify(item.templateQuesValue),
      version: item.version,
      zoneKeys: JSON.stringify(item.zoneKeys),
      userId: AgentId,
      segmentOrder: JSON.stringify(['Questionnaire', 'Media']),
    }));
    await this.idbservice.addTaskTemplateDataInBulk(preparedData);
  }

  async prepareTaskTemplateDataforUpdate(TaskTemplateDetail, AgentId: any, taskId: any) {
    const preparedData = TaskTemplateDetail.map(item => ({
      taskId: taskId,
      templateId: item.templateId,
      templateQues: item.templateQues,
      templateQuesValue: item.templateQuesValue
    }));
    await this.idbservice.updateTemplateQuesBulk(preparedData);
  }

  getLocalizedMessage(Message) {
    this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.orgId));
    const defaultLang = this.encryptionService.decrypt(this.encryptionService.localstorageDecrypt(this._appenum.EntityOfLocalStorageKeys.defaultLanguageSelected));
    return Message[this._appSetting.selectedLanguage] || Message[defaultLang];
  }

  deleteAgentDataByTaskId(taskId: string) {
    Object.keys(localStorage)
      .filter(key => key.endsWith(`_${taskId}`))
      .forEach(key => localStorage.removeItem(key));
  }



  // in your app service (e.g. AppServices, or wherever shared dynamic-form logic lives)
  validateAndRepairTemplateJson(
    flatTemplateJson: any[],
    tempTemplateData: any[],
    zoneIndex: number,
    templateId: any,
    logContext: { componentName: string; taskId: any; logLevel: any }
  ): any[] {
    if (!Array.isArray(flatTemplateJson)) {
      // console.error(`Zone ${zoneIndex} (templateId: ${templateId}): flatTemplateJson invalid, skipping validation`);
      const errMsg = `Zone ${zoneIndex} (templateId: ${templateId}): flatTemplateJson invalid, skipping validation`;
      this.logsActivity(
        this._appenum.EntityOfLogLevel.Error,
        errMsg,
        this.componentName,
        null,
        { zoneIndex, templateId },
        undefined,
        'validateAndRepairTemplateJson'
      );
      return flatTemplateJson;
    }

    const matchedTemp = Array.isArray(tempTemplateData)
      ? tempTemplateData.find(t => t.templateId === templateId)
      : null;

    if (!matchedTemp || !Array.isArray(matchedTemp.templateJson)) {
      const warnMsg = `Zone ${zoneIndex} (templateId: ${templateId}): no matching tempTemplateData entry found, skipping comparison`;
      this.logsActivity(
        this._appenum.EntityOfLogLevel.Error,
        warnMsg,
        this.componentName, // componentOrPage
        null,                             // httpRequest - not applicable
        { zoneIndex, templateId },        // taskDetails - carrying context, same pattern as before
        undefined,         // apiName - filterable bucket for these validation logs
        'validateAndRepairTemplateJson'   // functionName
      );
      return flatTemplateJson;
    }

    const originalJson = matchedTemp.templateJson;
    console.log("originalJson", originalJson)
    if (originalJson.length === flatTemplateJson.length) {
      return flatTemplateJson;
    }

    const presentNames = new Set(flatTemplateJson.map(c => c.name));
    const missingControls = originalJson.filter(c => !presentNames.has(c.name));

    if (missingControls.length === 0) {
      console.warn(
        `Zone ${zoneIndex} (templateId: ${templateId}): length mismatch ` +
        `(tempTemplateData: ${originalJson.length}, flat: ${flatTemplateJson.length}) but no missing names detected.`
      );
      return flatTemplateJson;
    }

    console.error(
      `Zone ${zoneIndex} (templateId: ${templateId}): MISSING CONTROLS DETECTED. ` +
      `tempTemplateData: ${originalJson.length}, flat: ${flatTemplateJson.length}, missing: ${missingControls.length}`,
      missingControls.map(c => ({ name: c.name, controlName: c.controlName, controlType: c.controlType }))
    );

    this.logsActivityOfRepairJson(
      logContext.logLevel,
      'Missing controls detected and auto-repaired',
      logContext.componentName,
      {
        method: 'validateAndRepairTemplateJson',
        templateId: templateId,
        zoneIndex: zoneIndex,
        tempTemplateDataCount: originalJson.length,
        flatCount: flatTemplateJson.length,
        missingControlNames: missingControls.map(c => c.name),
      },
      { TaskId: logContext.taskId },
      'validateAndRepairTemplateJson'
    );

    let repaired = [...flatTemplateJson];

    missingControls.forEach(control => {
      const clonedControl = JSON.parse(JSON.stringify(control));
      if (clonedControl.controlType === 'segment') {
        repaired.unshift(clonedControl); // force to index 0
      } else {
        repaired.push(clonedControl);
      }
    });

    return repaired;
  }

  parseIOSVersion(ua: string): string {
    const match = ua.match(/OS\s([0-9_]+)\slike Mac OS X/);
    return match ? match[1].replace(/_/g, '.') : 'unknown';
  }

  parseIOSModel(ua: string): string {
    if (/iPad/.test(ua)) return 'iPad';
    if (/iPhone/.test(ua)) return 'iPhone';
    if (/iPod/.test(ua)) return 'iPod';
    return 'unknown';
  }

  parseAndroidVersion(ua: string): string {
    const match = ua.match(/Android\s([0-9.]+)/);
    return match ? match[1] : 'unknown'; // frozen as e.g. "10" on modern Chrome
  }

  parseAndroidModel(ua: string): string {
    const match = ua.match(/;\s([A-Za-z0-9\-_ ]+)\sBuild\//);
    return match ? match[1].trim() : 'unknown';
  }

  async isFileUploadInProgress(taskId: string, orgId: string): Promise<boolean> {
    const InspectionFileData: any = await this.idbservice.getTaskFileDetailsToUploading(
      taskId, this.UploadMaxRetryHit, orgId
    );
    return InspectionFileData.length > 0;
  }
  isValidImageBuffer(buffer: ArrayBuffer | null | undefined): boolean {
    return !!buffer && buffer instanceof ArrayBuffer && buffer.byteLength > 0;
  }
  formatExpiryDate(rawDateTime: string): string {
    // rawDateTime looks like "2026-10-07 18:29:59"
    const [datePart] = rawDateTime.split(' ');       // "2026-10-07"
    const [year, month, day] = datePart.split('-');  // ["2026", "10", "07"]

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const monthName = monthNames[parseInt(month, 10) - 1];

    return `${monthName} ${day},${year}`; // "Oct 07,2026"
  }

  addTaskIdinUrl(taskId: any) {
    const url = new URL(window.location.href);
    url.search = '';
    url.searchParams.set('taskId', taskId);
    history.replaceState({ taskId: taskId }, '', url.toString());
  }
}